import {call, put, takeLatest} from 'redux-saga/effects';
import overviewActions from '../actions/overview.actions';
import OverviewApi from '../api/OverviewApi';
import errorActions from '../actions/error.actions';

function* fetchOverview(action) {
    try {
        const overview = yield call(OverviewApi.getOverviewData, action.payload);
        yield put(overviewActions.getHomeSuccess(overview));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(overviewActions.getHomeFailed(e));
    }
}

function* overviewSaga() {
    yield takeLatest(overviewActions.TYPES.GET_HOME, fetchOverview);
}

export default overviewSaga;
